import md5 from "md5";

export const addHeader = (config) => {
  let anTimestamp = Date.parse(new Date()).toString().substr(0, 10)
  let anSecret = ''
  for (let i = 0; i < 10; i++) {
    anSecret += String(Math.floor(Math.random() * 10))
  }
  let anToken = md5('oneWindow#' + anSecret + anTimestamp)
  config.headers['token'] = anToken
  config.headers['secret'] = anSecret
  config.headers['timestamp'] = anTimestamp
  config.headers['sign'] = encParams(config.params || config.data, anSecret)
  if (sessionStorage.getItem('token')) {
    config.headers.ow_token = sessionStorage.getItem('token') || store.state.token
  }
  if (sessionStorage.getItem('secret')) {
    config.headers.ow_secret = sessionStorage.getItem('secret') || store.state.secret
  }
}
const encParams = (params, secret) => {
  let tmp = []
  for (let key in params) {
    const value = params[key]
    if (value === null || value === undefined || value === '') {
      continue
    }
    tmp.push(key + '=' + value)
  }
  let tmpStr = tmp.sort().join('&')
  if (tmpStr) {
    tmpStr = `${tmpStr}&key=${secret}`
  } else {
    tmpStr = `key=${secret}`
  }
  // console.log('encParams: ', tmpStr)
  return md5(tmpStr).toUpperCase()
}
